"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickPropsSDKFactoryWithUpdatePlatformHandler = void 0;
const clickPropsSDKFactory_1 = require("./clickPropsSDKFactory");
const clickPropsSDKFactoryWithUpdatePlatformHandler = api => {
    const clickPropsApi = (0, clickPropsSDKFactory_1.clickPropsSDKFactory)(api);
    const { setProps, props } = api;
    return Object.assign(Object.assign({}, clickPropsApi), { onClick: handler => {
            clickPropsApi.onClick(handler);
            if (!props.hasPlatformClickHandler) {
                setProps({
                    hasPlatformClickHandler: true,
                });
            }
        } });
};
exports.clickPropsSDKFactoryWithUpdatePlatformHandler = clickPropsSDKFactoryWithUpdatePlatformHandler;
//# sourceMappingURL=clickPropsSDKFactoryWithPlatformHandler.js.map